import styled from "styled-components";

export const Wrapper = styled.div`
display: flex;
width: 100%;
flex-direction: column;
/* >div:nth-of-type(2n){
border-top: 2px solid #e3e3e3;
} */
`;